import { MetadataFieldRelationByIntegrationType } from '@modules/integrationsV2/store/types';
import { IntegrationSource } from '@modules/integrationsV2/types';

interface GetExistingFieldsRelationParams {
  fieldRelationsByType: MetadataFieldRelationByIntegrationType[];
  sourceIntegrationSource: IntegrationSource;
  targetIntegrationSource: IntegrationSource;
}

export const getExistingFieldsRelation = ({
  fieldRelationsByType,
  sourceIntegrationSource,
  targetIntegrationSource,
}: GetExistingFieldsRelationParams) => {
  return fieldRelationsByType.find((fieldRelation) => {
    const MetadataFieldRelation =
      fieldRelation[sourceIntegrationSource.integrationType];
    const targetFieldRelation =
      fieldRelation[targetIntegrationSource.integrationType];

    const areTypesPresent = !!MetadataFieldRelation && !!targetFieldRelation;
    const areSourcesMatching =
      MetadataFieldRelation?.source === sourceIntegrationSource.source &&
      targetFieldRelation?.source === targetIntegrationSource.source;

    return areTypesPresent && areSourcesMatching;
  });
};
